import { render } from "./EditRecipe.vue?vue&type=template&id=271d0347&scoped=true"
import script from "./EditRecipe.vue?vue&type=script&lang=js"
export * from "./EditRecipe.vue?vue&type=script&lang=js"

import "./EditRecipe.vue?vue&type=style&index=0&id=271d0347&scoped=true&lang=css"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271d0347"]])

export default __exports__